import { PlayerPlayIcon } from 'foundations-assets/icons/components/PlayerPlayIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function formatClipDuration(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) {
    return `${seconds}s`;
  }
  return `${minutes}m ${seconds.toString().padStart(2, '0')}s`;
}
const formatVideoStartTime = seconds => {
  const totalSeconds = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(totalSeconds / 60);
  const remainingSeconds = totalSeconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};
export const ProgressBarWithTooltip = ({
  borderRadius = '200',
  clipLength,
  clipStartTime,
  startPercent,
  widthPercent
}) => {
  const positionTooltipAtCenter = clipStartTime < 30 || clipLength < 60;
  const anchorWidth = positionTooltipAtCenter ? `${widthPercent}%` : '1px';
  const tooltipContent = positionTooltipAtCenter ? /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(PlayerPlayIcon, {
      color: "fill-surface-default"
    }), /*#__PURE__*/_jsx(Text, {
      children: formatClipDuration(clipLength)
    })]
  }) : /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    gap: "100",
    children: [/*#__PURE__*/_jsx(PlayerPlayIcon, {
      color: "fill-surface-default"
    }), /*#__PURE__*/_jsx(Text, {
      children: formatVideoStartTime(clipStartTime)
    })]
  });
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    backgroundColor: "fill-surface-default",
    blockSize: "6px",
    borderRadius: borderRadius,
    "data-test-id": "progress-bar-with-clip",
    inlineSize: "100%",
    position: "relative",
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "100%",
      inlineSize: anchorWidth,
      insetInlineStart: `${startPercent}%`,
      position: "absolute",
      children: /*#__PURE__*/_jsx(Tooltip, {
        autoPlacement: false,
        "data-test-id": "progress-bar-with-clip-tooltip",
        open: true,
        placement: "top",
        title: tooltipContent,
        children: /*#__PURE__*/_jsx(View, {
          blockSize: "100%",
          inlineSize: "100%"
        })
      })
    }), /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-info-default",
      blockSize: "100%",
      "data-test-id": "progress-bar-with-clip-fill",
      inlineSize: `${widthPercent}%`,
      insetInlineStart: `${startPercent}%`,
      position: "absolute"
    })]
  });
};